import React from 'react';

const ModalOverlay = ({ display, children }) => {

const displayParam = (display == false ? 'none' : 'block');

  const overlayStyle = {
    position: 'fixed',
    display: displayParam,
    marginLeft: '60px',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(19, 20, 21, 0.25)',
    boxShadow: 'inset 0 1px 3px 0 rgba(255,255,255,0.5)',
    zIndex: 2,
    cursor: 'default'
  };

  return <div style={overlayStyle}>{children}</div>;
};

export default ModalOverlay;
